import axios from 'axios';

const API_BASE_URL = '/api/burn-cash-token-requests';

export const burnCashTokenRequestsAPI = {
    /**
     * Get all burn cash token requests
     */
    getAllRequests: async (params = {}) => {
        const query = {};
        if (params.page) query.page = params.page;
        if (params.limit) query.limit = params.limit;
        if (params.status) query.status = params.status;
        if (params.search) query.search = params.search;

        const response = await axios.get(API_BASE_URL, {
            params: query,
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
            }
        });
        return response.data;
    },

    /**
     * Get burn cash token request by ID
     */
    getRequestById: async (id) => {
        const response = await axios.get(`${API_BASE_URL}/${id}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
            }
        });
        return response.data;
    },

    /**
     * Approve burn cash token request at L1
     */
    approveL1: async (id, notes = '') => {
        const response = await axios.post(
            `${API_BASE_URL}/${id}/approve-l1`,
            { notes },
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            }
        );
        return response.data;
    },

    /**
     * Approve burn cash token request at L2
     */
    approveL2: async (id, notes = '') => {
        const response = await axios.post(
            `${API_BASE_URL}/${id}/approve-l2`,
            { notes },
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            }
        );
        return response.data;
    },

    /**
     * Upload payment reference files for burn cash token request
     */
    uploadPaymentReference: async (id, formData) => {
        const response = await axios.post(
            `${API_BASE_URL}/${id}/payment-reference`,
            formData,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                    'Content-Type': 'multipart/form-data'
                }
            }
        );
        return response.data;
    }
};

export default burnCashTokenRequestsAPI;
